import { render } from "./BlogPageAveBottle.vue?vue&type=template&id=7d81ed13&scoped=true"
import script from "./BlogPageAveBottle.vue?vue&type=script&lang=js"
export * from "./BlogPageAveBottle.vue?vue&type=script&lang=js"

import "./BlogPageAveBottle.vue?vue&type=style&index=0&id=7d81ed13&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d81ed13"]])

export default __exports__